exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\nbody{\r\n    margin: 0;\r\n}\r\nripple{\r\n      overflow:hidden!important;\r\n      cursor: pointer;\r\n    }\r\n\r\n     .ripple-effect{\r\n      position: absolute;\r\n      overflow:hidden!important;\r\n      border-radius: 50%;\r\n      width: 50px;\r\n      height: 50px;\r\n      background: white;\r\n      animation: ripple-animation 2.5s;\r\n    }\r\n\r\n\r\n     @keyframes ripple-animation {\r\n      from {\r\n        transform: scale(1);\r\n        opacity: 0.4;\r\n      }\r\n      to {\r\n        transform: scale(100);\r\n        opacity: 0;\r\n      }\r\n    }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./~/angular-ripple-effect/style.css
// module id = 521
// module chunks = 2